// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","headerPanel":"App_headerPanel__YDT7X","eqPanel":"App_eqPanel__IpwZH","controlsPanel":"App_controlsPanel__U4OG9","pianoPanel":"App_pianoPanel__-bcVw"};